import { useCrmUrl } from '@/utils/crm-url';

export function DonorLink({
  donorId,
  donorName,
}: {
  donorId: string;
  donorName: string;
}) {
  const crmUrl = useCrmUrl();
  if (!crmUrl) {
    return donorName;
  }

  const url = new URL('main.aspx', crmUrl);
  url.searchParams.set('etc', '10012');
  url.searchParams.set(
    'extraqs',
    'formid=55e68fe8-441c-4368-9a99-d2034a0330bf',
  );
  url.searchParams.set('id', `{${donorId}}`);
  url.searchParams.set('pagetype', 'entityrecord');

  return (
    <a href={url.toString()} target="_blank" rel="noopener noreferrer">
      {donorName}
    </a>
  );
}
